// Generated by purs version 0.13.8
"use strict";
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Monoid_Additive = require("../Data.Monoid.Additive/index.js");
var Data_Monoid_Dual = require("../Data.Monoid.Dual/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Group = function (Monoid0, ginverse) {
    this.Monoid0 = Monoid0;
    this.ginverse = ginverse;
};
var groupUnit = new Group(function () {
    return Data_Monoid.monoidUnit;
}, function (v) {
    return Data_Unit.unit;
});
var groupAdditive = function (dictRing) {
    return new Group(function () {
        return Data_Monoid_Additive.monoidAdditive(dictRing.Semiring0());
    }, function (v) {
        return Data_Ring.negate(dictRing)(v);
    });
};
var ginverse = function (dict) {
    return dict.ginverse;
};
var groupDual = function (dictGroup) {
    return new Group(function () {
        return Data_Monoid_Dual.monoidDual(dictGroup.Monoid0());
    }, function (v) {
        return ginverse(dictGroup)(v);
    });
};
var power = function (dictGroup) {
    return function (x) {
        return function (p) {
            if (p < 0) {
                return Data_Monoid.power(dictGroup.Monoid0())(ginverse(dictGroup)(x))(-p | 0);
            };
            if (Data_Boolean.otherwise) {
                return Data_Monoid.power(dictGroup.Monoid0())(x)(p);
            };
            throw new Error("Failed pattern match at Data.Group (line 32, column 1 - line 32, column 44): " + [ x.constructor.name, p.constructor.name ]);
        };
    };
};
module.exports = {
    ginverse: ginverse,
    Group: Group,
    power: power,
    groupUnit: groupUnit,
    groupDual: groupDual,
    groupAdditive: groupAdditive
};
